import { useContext, useEffect } from "react";

import FooterClasses from './AppFooter.module.css';
import { NavLink } from "react-router-dom";

function TidioChat() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//code.tidio.co/fxuxkfz0dgmowjhk5qtzktqhli9lo5jg.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script); // cleanup if needed
    };
  }, []);

  return null;
}

const CTS_Footer = () => {
	
    return (
               <div className={FooterClasses.footerRoot}>

			
				<div className={FooterClasses.categoryItemHeader}><h1>Discover Employer Services</h1></div>
				  <div className={FooterClasses.imageRow}>

					<div className={FooterClasses.imageWrapper}>
						<a href="https://drugtestingassociates.com/consortium/" target="consort" className={FooterClasses.service}>
						  <div className={FooterClasses.imageWithIcon}>
							<img
							  src="../images/CTS/Consortium.png"
							  alt="Consortium"
							  className={FooterClasses.mainImage}
							/>
							<img
							  src="../images/Icons/Consortium.png"
							  alt="Consortium Icon"
							  className={FooterClasses.overlayIcon}
							/>
						  </div>
						  <div className={FooterClasses.serviceTitle}>Consortium</div>
						  <div className={FooterClasses.serviceDescription}>Collaborate with a trusted network of experts in drug testing.<br/></div>
						</a>
					</div>

					<div className={FooterClasses.imageWrapper}>
						<a href="https://drugtestingassociates.com/employer-services/" target="consort" className={FooterClasses.service}>
						  <div className={FooterClasses.imageWithIcon}>
							  <img
								src="../images/CTS/Training.png"
								alt="Training"
								style={{ marginTop: '10px' }}
							  />
							  <img
								src="../images/Icons/Training.png"
								alt="Consortium Icon"
								className={FooterClasses.overlayIcon}
								/>
						  </div>
						  <div className={FooterClasses.serviceTitle}>Training</div>
						  <div className={FooterClasses.serviceDescription}>Equip yourself with the expertise to effectively supervise drug testing processes.</div>
						</a>
					</div>

					<div className={FooterClasses.imageWrapper}>
						<a href="https://drugtestingassociates.com/employer-services/" target="consort" className={FooterClasses.service}>
							<div className={FooterClasses.imageWithIcon}>
							  <img
									src="../images/CTS/Clearinghouse.png"
									alt="Clearinghouse"
									style={{ marginTop: '10px' }}
								  />
							  <img
								src="../images/Icons/Clearinghouse.png"
								alt="Consortium Icon"
								className={FooterClasses.overlayIcon}
								/>
						  </div>
						  <div className={FooterClasses.serviceTitle}>Clearinghouse</div>
						  <div className={FooterClasses.serviceDescription}>Make confident hiring decisions with our thorough and reliable background check services.</div>
						</a>
					</div>

				  </div>
			
			<div>
			<br/>
		    <div className={FooterClasses.categoryItemHeader}><h1> Achieve Better Health Through Expert Insights</h1></div>
			<div className={FooterClasses.categoryItemSubHeader}> Helpful resources with tips to support your health, whether for work or personal well-being.</div>
			<div className={FooterClasses.services}>
				<a  className={FooterClasses.service} href="https://drugtestingassociates.com/blog/" target="blog">
					<div className={FooterClasses.insightsLink} >
						<img alt='wording goes here' className={FooterClasses.iconImage} src={`../images/Icons/Blog.png`} />
					</div>	
					<div className={FooterClasses.insightsTitle}>
						<h3>Blog</h3> <p>Stay updated with the latest news, trends, and expert insights in drug testing and clinical lab & wellness testing.</p>
					</div>						
				</a>
				<a className={FooterClasses.service} href="https://drugtestingassociates.com/test-glossary/" target="glossary">
					<div className={FooterClasses.insightsLink} >
						<img alt='wording goes here' className={FooterClasses.iconImage} src={`../images/Icons/Glossary.png`} />
					</div>	
					<div className={FooterClasses.insightsTitle}>
						<h3>Glossary</h3> <p>Understand key drug testing terms from A to Z, with complex topics made easier to understand.</p>
					</div>						
				</a>				
				<a className={FooterClasses.service} href="https://drugtestingassociates.com/faqs/" target="FAQ">
					<div className={FooterClasses.insightsLink} >
						<img alt='wording goes here' className={FooterClasses.iconImage} src={`../images/Icons/FAQs.png`} />
					</div>	
					<div className={FooterClasses.insightsTitle}>
						<h3>FAQs</h3> <p>Get answers to common questions about our services and drug testing processes.</p>
					</div>						
				</a>
			
		   </div>
		  <br/>
			<TidioChat />
		   <div className={FooterClasses.appFooterSp}> 
			    <p>Can’t find the right test you need? Got questions about drug testing?
			        <br />
			        Call us at <span className={FooterClasses.phone}> 833-728-9800 </span> -- we're here to help!
			    </p>
			</div>
		  </div>
		  <script src="//code.tidio.co/fxuxkfz0dgmowjhk5qtzktqhli9lo5jg.js"></script>
        </div>
    );
};

export default CTS_Footer;